import { LineChart, Line } from "recharts";

// Tiny inline sparkline. Uses fixed dimensions (no ResponsiveContainer) to avoid
// the recharts width(-1) warnings that fire when the parent table cell hasn't
// laid out yet on first render.
export default function Sparkline({ data = [], color = "#E3000B", height = 28, width = 80 }) {
  if (!data || data.length < 2) {
    return <div className="text-[10px] text-gray-400 font-mono" style={{ width, height, lineHeight: `${height}px`, textAlign: "center" }}>—</div>;
  }
  const chartData = data.map((v, i) => ({ i, v }));
  return (
    <LineChart width={width} height={height} data={chartData}>
      <Line type="monotone" dataKey="v" stroke={color} strokeWidth={1.5} dot={false} isAnimationActive={false} />
    </LineChart>
  );
}
